import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const VENDEDOR_PREFIX = `${APP_PREFIX_PATH}/vendedor`;

const MeusAtivos = lazy(() => import("./meus-ativos"));

export const VendedorViews = () => (
	<Suspense fallback={<Loading cover="content" />}>
		<Switch>
			<Route path={`${VENDEDOR_PREFIX}/meus-ativos`} component={MeusAtivos} />
			<Redirect from={`${VENDEDOR_PREFIX}`} to={`${VENDEDOR_PREFIX}/meus-ativos`} />
		</Switch>
	</Suspense>
);

export default VendedorViews;
